import React from "react";
import '@abb/abb-common-ux-react/styles.css';
import "./shared.sass";
import { Translation } from "react-i18next";
import * as CONSTANTS from "../../utilities/Constants";

interface ISidebarTitleProperties {
    title: string,
    selectedCount?: number
}

class SidebarTitle extends React.Component<ISidebarTitleProperties> {
    public render() {
        return (
            <Translation>
                {
                    t =>
                        <React.Fragment>
                            <div className="bg-color">
                                <span className="sidebar-title font-weight-bold">{t(this.props.title)}</span>
                                {this.props.selectedCount ? <span className="float-right">{this.props.selectedCount} {t(CONSTANTS.SELECTED)}</span> :null}
                            </div>
                        </React.Fragment>
                }
            </Translation>
        );
    }
}

export default SidebarTitle;


